<template>
  <div v-show="isLoaded" class="mAge-gate-section" v-observe-visibility="startAnimate">
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
export default {
  name: "AgeGate",
  components: {},
  data() {
    return {
      animate: false
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  computed: {
    ...mapGetters(["isLoaded"]),
  },
  methods: {
    startAnimate(isVisible){
      if(isVisible){
        this.animate=true
      }
    }, 
    ...mapActions({
      setAgeGateTokenAction: "setAgeGateToken",
    }),
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    focusNextSibling(event) {
      const element = event.target;
      if (
        element &&
        element.value &&
        element.value.length === event.target.maxLength
      ) {
        event.target.nextElementSibling.focus();
      }
    },
  },
  mounted() {
    this.$nextTick(() => {});
  },
};
</script>

<style scoped lang="scss">
@import "~@/styles/agegatem.scss";
</style>
